import { render } from "./ExpenseReceiptCreate.vue?vue&type=template&id=7b079b56"
import script from "./ExpenseReceiptCreate.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__